import React, { useEffect } from 'react';
import { productSubsteps } from '@helpers/Constants';
import { Breadcrumbs } from '@components/Breadcrumbs';
import { ButcherHeader } from '@components/ButcherHeader';
import ProductList from '@components/Products/ProductList';
import { useLocation } from 'react-router-dom';
import { OnBoardSettings } from '@components/OnBoardSettings';

export const Products: React.FC = () => {
  const location = useLocation();
  const fromSettings = location.state?.fromSettings;
  /**
   * Triggers `fetchMinType` whenever `newMinTypeData` changes.
   *
   * This effect runs every time `newMinTypeData` updates.
   * It ensures that `fetchMinType` is called to retrieve or refresh the minimum type data.
   *
   * Dependencies:
   * - `newMinTypeData`: The effect re-runs whenever this value changes.
   */
  useEffect(() => {
    // Calling this function when new min type added
  }, []);

  const renderContent = (
    <>
      {/* Breadcrumbs */}
      <div>
        <Breadcrumbs
          title="Configure Settings"
          activeMainNav="Products"
          activeStep={1}
          subNavSteps={productSubsteps}
          fromSettings={fromSettings ? true : false}
        />
      </div>
      <hr className="my-4 border-t border-gray-300" />

      <div>
        <ProductList></ProductList>
      </div>
    </>
  );
  return (
    <>
      {!fromSettings ? (
        <div className="w-screen h-screen overflow-auto flex justify-center items-start">
          <div className="w-11/12 p-4">
            <ButcherHeader isOnBoarding={true} />

            {renderContent}
          </div>
        </div>
      ) : (
        <OnBoardSettings renderContent={renderContent} speciesSetup={true} />
      )}
    </>
  );
};
